import React from 'react';

const Footer = () => {
    return (
        <>
               <footer>
                <div className="top-footer">
                    <div className="container">
                        <div className="row">
                          
                          
                            <div className="col-md-3 col-sm-6 col-xs-12 footy">
                                <section className="list">
                                    <header>
                                        <h4>Quick Access</h4>
                                    </header>
                                    <ul>
                                        <li>
                                            <a href="" >All Courses</a>
                                        </li>
                                        <li>
                                            <a href="">Purchase Rules </a>
                                        </li>
                                        <li>
                                            <a href="">Shopping Giude </a>
                                        </li>
                                        <li>
                                            <a href="">Cooperation with Ciademy </a>
                                        </li>
                                        <li>
                                            <a href="">Earning money from Ciademy </a>
                                        </li>
                                        <li >
                                            <a href="" >Monthly Journal</a>
                                        </li>
                                    </ul>
                                </section>
                            </div>
                            <div className="col-md-3 col-sm-6 col-xs-12 footy">
                                <section className="list">
                                    <header>
                                        <h4>Quick Access</h4>
                                    </header>
                                    <ul>
                                        <li>
                                            <a href="">All Courses</a>
                                        </li>
                                        <li>
                                            <a href="">Purchase Rules </a>
                                        </li>
                                        <li>
                                            <a href="">Shopping Giude </a>
                                        </li>
                                        <li>
                                            <a href="">Cooperation with Ciademy </a>
                                        </li>
                                        <li>
                                            <a href="">Earning money from Ciademy </a>
                                        </li>
                                        <li>
                                            <a href="">Monthly Journal</a>
                                        </li>
                                    </ul>
                                </section>
                            </div>
                            <div className="col-md-3 col-sm-6 col-xs-12 footy">
                                <section className="list">
                                    <header>
                                        <h4>Quick Access</h4>
                                    </header>
                                    <ul>
                                        <li>
                                            <a href="">All Courses</a>
                                        </li>
                                        <li>
                                            <a href="">Purchase Rules </a>
                                        </li>
                                        <li>
                                            <a href="">Shopping Giude </a>
                                        </li>
                                        <li>
                                            <a href="">Cooperation with Ciademy </a>
                                        </li>
                                        <li>
                                            <a href="">Earning money from Ciademy </a>
                                        </li>
                                        <li>
                                            <a href="">Monthly Journal</a>
                                        </li>
                                    </ul>
                                </section>
                            </div>
                            <div className="col-md-3 col-sm-6 col-xs-12 footy">
                                <section className="list">
                                    <header>
                                        <h4>Quick Access</h4>
                                    </header>
                                    <ul>
                                        <li>
                                            <a href="">All Courses</a>
                                        </li>
                                        <li>
                                            <a href="">Purchase Rules </a>
                                        </li>
                                        <li>
                                            <a href="">Shopping Giude </a>
                                        </li>
                                        <li>
                                            <a href="">Cooperation with Ciademy </a>
                                        </li>
                                        <li>
                                            <a href="">Earning money from Ciademy </a>
                                        </li>
                                        <li>
                                            <a href="">Monthly Journal</a>
                                        </li>
                                    </ul>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="bottom-footer">
                    <div className="container">
                        <p>
                        Copyright {" "} &copy;  {new Date().getFullYear()}
                                    &nbsp; CIADEMY - All Rights Reserved
                        </p>
                    </div>
                </div>
            </footer>
        </>
      );
}
 
export default Footer;
   